module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-14-37-354_com.pinkcoffee.sexbattle.c43d141b.jpg";